import React from 'react';
import { Container } from 'react-bootstrap';
import Card from 'shared/components/Card';

export function EmailRequiredBlock() {

  return (
    <Container>
      <Card variant="error" className="mt-4 p-4">
        <h3 className="fw-semibold">ATENCIÓN</h3>
        <br />
        <p>
          No puedes operar en la plataforma sin un correo electrónico registrado.
          Proporciona un correo electrónico al administrador del sistema para poder operar en la plataforma
        </p>
        <br />
        <div className="text-end">

        </div>
      </Card>
    </Container>
  );
}